import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseDiscountCreatedTemplates = [
  {
    id: '-112001',
    language: Language.EN,
    subject: 'A discount has been added to your lease',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_DISCOUNT_CREATED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Dear {{listAllTenants lease}},</p>
        <p></p>
        <p>Concerns: discount on the lease located at <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>We are pleased to inform you that you have been granted a discount.</p>
        <p></p>
        <p>Discount details:</p>
        <ul>
        <li>Label: <strong>{{lvoLabel lvo language}}</strong></li>
        <li>Amount: <strong>{{lvo.amount}} €</strong></li>
        {{#if (hasReason lvo)}}
        <li>Comment: <strong>{{lvo.reason}}</strong></li>
        {{/if}}
        <li>Start date: <strong>{{lvoStartDate lvo}}</strong></li>
        <li>Duration: <strong>{{lvoDuration lvo language}}</strong></li>
        </ul>
        <p></p>
        <p>This discount will be subject to a specific line on your {{getInvoiceOrPaymentRequest lease}}.</p>
        <p></p>
        <p>Kind regards,</p>
        <p></p>
        <p>{{accountSignature client}}</p>`,
  },
  {
    id: '-112002',
    language: Language.FR,
    subject: 'Une remise a été ajoutée à votre bail',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_DISCOUNT_CREATED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Cher/Chère {{listAllTenants lease}},</p>
        <p></p>
        <p>Concerne: une remise a été ajoutée au bail sis <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Nous avons le plaisir de vous informer qu'une remise vous est octroyée.</p>
        <p></p>
        <p>Détails de la remise:</p>
        <ul>
        <li>Libellé: <strong>{{lvoLabel lvo language}}</strong></li>
        <li>Montant: <strong>{{lvo.amount}} €</strong></li>
        {{#if (hasReason lvo)}}
        <li>Commentaire: <strong>{{lvo.reason}}</strong></li>
        {{/if}}
        <li>Date de début: <strong>{{lvoStartDate lvo}}</strong></li>
        <li>Durée: <strong>{{lvoDuration lvo language}}</strong></li>
        </ul>
        <p></p>
        <p>La remise fera l'objet d'une ligne spécifique sur votre {{getInvoiceOrPaymentRequest lease}}.</p>
        <p></p>
        <p>Bien à vous,</p>
        <p></p>
        <p>{{accountSignature client}}</p>`,
  },
  {
    id: '-112003',
    language: Language.NL,
    subject: 'Een korting werd aan uw huurcontract toegevoegd',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_DISCOUNT_CREATED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Geachte {{listAllTenants lease}},</p>
        <p></p>
        <p>Betreffende: korting op uw huurcontract gelegen te <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Wij zijn verheugd u te kunnen meedelen dat u een korting heeft gekregen.</p>
        <p></p>
        <p>Details korting:</p>
        <ul>
        <li>Label: <strong>{{lvoLabel lvo language}}</strong></li>
        <li>Bedrag: <strong>{{lvo.amount}} €</strong></li>
        {{#if (hasReason lvo)}}
        <li>Opmerking: <strong>{{lvo.reason}}</strong></li>
        {{/if}}
        <li>Begindatum: <strong>{{lvoStartDate lvo}}</strong></li>
        <li>Duur: <strong>{{lvoDuration lvo language}}</strong></li>
        </ul>
        <p></p>
        <p>Voor deze korting zal een specifieke rubriek op uw {{getInvoiceOrPaymentRequest lease}} worden vermeld.</p>
        <p></p>
        <p>Met vriendelijke groeten,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-112004',
    language: Language.DE,
    subject: 'Ein Rabatt wurde zu Ihrem Mietvertrag hinzugefügt',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_DISCOUNT_CREATED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Liebe/r {{listAllTenants lease}},</p>
        <p></p>
        <p>Betreff: Rabatt auf den Mietvertrag in <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Wir freuen uns, Ihnen mitteilen zu können, dass Ihnen ein Rabatt gewährt wurde.</p>
        <p></p>
        <p>Rabatt-Details:</p>
        <ul>
        <li>Bezeichnung: <strong>{{lvoLabel lvo language}}</strong></li>
        <li>Betrag: <strong>{{lvo.amount}} €</strong></li>
        {{#if (hasReason lvo)}}
        <li>Kommentar: <strong>{{lvo.reason}}</strong></li>
        {{/if}}
        <li>Startdatum: <strong>{{lvoStartDate lvo}}</strong></li>
        <li>Dauer: <strong>{{lvoDuration lvo language}}</strong></li>
        </ul>
        <p></p>
        <p>Dieser Rabatt wird als spezifische Position auf Ihrer {{getInvoiceOrPaymentRequest lease}} ausgewiesen.</p>
        <p></p>
        <p>Mit freundlichen Grüßen,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
];
